import React from 'react';
import { createRoot } from 'react-dom/client'; // Importe createRoot
import App from './App';
import reportWebVitals from './reportWebVitals';

// Crie a raiz para renderização
const root = createRoot(document.getElementById('root'));

// Renderize o aplicativo
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Opcional: Reporte métricas de desempenho
reportWebVitals();